import React, { useEffect } from "react"
import CaseHeader from "../../features/case-header"
import TechnologiesList from "../../features/technologies-list"
import PythonLogo from "../../assets/images/technologies/Python.svg"
import ReactLogo from "../../assets/images/technologies/React.svg"
import AWSLogo from "../../assets/images/technologies/aws.svg"
import DjangoLogo from "../../assets/images/technologies/django.svg"
import FastApiLogo from "../../assets/images/technologies/fastapi.svg"
import ServerlessLogo from "../../assets/images/technologies/serverless.svg"
import ShopifyLogo from "../../assets/images/technologies/shopify.svg"
import Stripe from "../../assets/images/technologies/stripe.svg"
import CaseProjectBlock from "../../features/case-project-block"
import { DEVELOPERS_LIST_TRY_NOW } from "../../data/cases/developers-data"
import CaseDeveloper from "../../features/case-developer"
import CasesSays from "../../features/cases-client"

import { OUR_CLIENTS } from "../../data/home/our-clients"
import { TRY_NOW } from "../../data/cases/seo-says"
import ChallengesSolutions from "../../features/challenges-solutions"
import { CHALLENGES_LIST_TRYNOW } from "../../data/cases/challenges-data"
import { SOLUTIONS_LIST_TRYNOW } from "../../data/cases/solutions-data"
import { HEADER_TRY_NOW } from "../../data/cases/headers-data"
import { PROJECT_TRY_NOW } from "../../data/cases/project-data"
import { OtherCases } from "../../features/other-cases"
import { useMediaQuery } from "react-responsive"
import { DESKTOP_WIDTH } from "../../constants/common"
import { Helmet } from "react-helmet-async"
import "./index.scss"

const TryNow = () => {
    const isDesktop = useMediaQuery({ minWidth: DESKTOP_WIDTH })

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Helmet defer={false}>
                <title>Newsoft - TryNow</title>
            </Helmet>
            <div className="try-now">
                <CaseHeader {...HEADER_TRY_NOW} />
                <div className="try-now-image">
                    <img
                        src="https://s3.amazonaws.com/staging.newsoft-website-v2/media/trynow_case/TryNow.webp"
                        alt="Trynow main"
                    />
                </div>
                <TechnologiesList title="Key technologies">
                    <img
                        src={PythonLogo}
                        alt="Python logo"
                        style={isDesktop ? { width: "50px" } : {}}
                    ></img>
                    <img
                        src={AWSLogo}
                        alt="AWS logo"
                        style={isDesktop ? { width: "68px" } : {}}
                    ></img>
                    <img
                        src={FastApiLogo}
                        alt="FA logo"
                        style={isDesktop ? { width: "46px" } : {}}
                    ></img>
                    <img
                        src={ServerlessLogo}
                        alt="Serverless logo"
                        style={isDesktop ? { width: "147px" } : {}}
                    ></img>
                    <img
                        src={Stripe}
                        alt="Stripe logo"
                        style={isDesktop ? { width: "70px" } : {}}
                    ></img>
                    <img
                        src={DjangoLogo}
                        alt="Django logo"
                        style={isDesktop ? { width: "69px" } : {}}
                    ></img>
                    <img
                        src={ShopifyLogo}
                        alt="Shopify logo"
                        style={isDesktop ? { width: "42px" } : {}}
                    ></img>
                    <img
                        src={ReactLogo}
                        alt="React logo"
                        style={!isDesktop ? { width: "44px" } : {}}
                    ></img>
                </TechnologiesList>
                <CaseProjectBlock {...PROJECT_TRY_NOW} />
                <CasesSays
                    data={OUR_CLIENTS[1]}
                    header="What our client says"
                />
                <div className="try-now-developers">
                    <h2 className="t-s3 desk">developer quotes</h2>
                    {DEVELOPERS_LIST_TRY_NOW.map((el, id) => (
                        <CaseDeveloper
                            key={el.name}
                            {...el}
                            header={id === 0 && "developer quotes"}
                        />
                    ))}
                </div>
                <CasesSays
                    more
                    ceo={true}
                    data={TRY_NOW}
                    header="What our CEO says"
                />
                <ChallengesSolutions
                    challenges={CHALLENGES_LIST_TRYNOW}
                    solutions={SOLUTIONS_LIST_TRYNOW}
                    subheaderSolutions="The team with Shopify API expertise:"
                />
                <div className="try-now-practice">
                    <h1 className="t-s3">Powerful Practice</h1>
                    <p className="t-b4">
                        The development and testing of the product took 24/7 and
                        this is a powerful practice . One half of the day worked
                        Ukrainian team, and the other - the American team.
                    </p>
                </div>
                <div className="try-now-assistance">
                    <h1 className="t-h3">Round-the-clock assistance</h1>
                    <p className="t-b1">
                        The technical support of the product took 24/7, with the
                        Ukrainian team working during one half of the day and
                        the American team during the other half. This approach
                        allowed us to have someone from the technical team
                        online at all times to address urgent inquiries or
                        perform necessary fixes.
                    </p>
                </div>
                <OtherCases currentCase="/cases/try-now" />
            </div>
        </>
    )
}

export default TryNow
